import React, { useState, Fragment } from 'react';
import { Button } from 'reactstrap';
import { UploadImagesForm } from './UploadIconsForm';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function UploadImagesButton({
    id,
    propertyId,
    bmb,
    parentLoadData,
    parentBmbData
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <Fragment>
            <Button
                color="secondary"
                className="add-button"
                size="xs"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                <FontAwesomeIcon icon={faPlus} style={{marginBottom :'0rem'}} />
                <span> </span>
                Upload Icons
            </Button>

            {isUpdating && (
                <UploadImagesForm
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Upload Icons"
                    visible={isUpdating}
                    propertyId={propertyId}
                    bmb={bmb}
                    parentLoadData={parentLoadData}
                    parentBmbData={parentBmbData}
                />
            )}
        </Fragment>
    );
}

